<template>
  <wa-modal-frame
    :is-showing="isShowing"
    has-actions
    @close-modal="closeModal"
  >
    <div slot="content">
      <section
        style="
          margin-inline: calc(-1 * var(--card-horizontal-padding));
          margin-top: calc(-1 * var(--card-vertical-padding));
          border-radius: var(--card-border-radius) var(--card-border-radius) 0 0;
          overflow: hidden;
        "
      >
        <img
          src="/images/icons/packs/utility/utility-thumb.svg"
          alt="Utility Icon Pack"
          style="width: 100%; height: 100%; object-fit: cover"
        />
      </section>
      <section class="text-left">
        <h2 class="margin-top-sm margin-bottom-2xs">Introducing: Utility!</h2>
        <p class="margin-bottom-md">
          Our newest Pro+ icon pack is here and ready to work. With a Bauhaus-inspired blend of sharp corners and smooth curves, this pack fits seamlessly into any
          project and gets the job done.
        </p>
        <p><strong>Limited-time offer:</strong> Get 20% off your first year of Pro+ with code <strong>UTILITY</strong>.</p>
      </section>
    </div>
    <div
      slot="actions"
      class="display-flex flex-column flex-items-center tablet:flex-row tablet:flex-content-between"
      style="--button-margin-bottom: 0; gap: var(--spacing-md)"
    >
      <site-link
        :to="$pack({ name: 'utility' })"
        class="button block"
        >Explore Utility</site-link
      >
      <site-link
        :to="{ name: 'plans.pro-plus', query: { discount: 'UTILITY' } }"
        class="button block teal"
        >Get 20% Off Pro+</site-link
      >
    </div>
  </wa-modal-frame>
</template>

<script>
  import { ModalFrameMixin } from 'app/components-wa/modals/ModalFrame'

  export default {
    name: 'ModalUtilityAnnouncement',

    mixins: [ModalFrameMixin],

    methods: {
      closeModal() {
        this.$emit('close-modal')
      }
    }
  }
</script>
